import { render, staticRenderFns } from "./Gamelist.vue?vue&type=template&id=9c6db46c&scoped=true&"
import script from "./Gamelist.vue?vue&type=script&lang=js&"
export * from "./Gamelist.vue?vue&type=script&lang=js&"
import style0 from "./Gamelist.vue?vue&type=style&index=0&id=9c6db46c&prod&lang=css&"
import style1 from "./Gamelist.vue?vue&type=style&index=1&id=9c6db46c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6db46c",
  null
  
)

export default component.exports